import {
  File02,
  FileAttachment03,
  Image01,
  VideoRecorder,
  VolumeMin,
} from 'ethena-icons';
import _ from 'lodash';

interface FileIconProps {
  fileName: string;
  className?: string;
}

const getFileIcon = (fileExtension: string) => {
  switch (fileExtension) {
    case 'docx':
    case 'pdf':
      return File02;
    case 'zip':
      return FileAttachment03;
    case 'mp4':
      return VideoRecorder;
    case 'mp3':
      return VolumeMin;
    case 'jpg':
    case 'jpeg':
    case 'png':
      return Image01;
    default:
      return File02;
  }
};

export const FileIcon = ({ className, fileName }: FileIconProps) => {
  if (!fileName) {
    return null;
  }

  const fileExtension = _.chain(fileName).split('.').last().toLower().value();
  const Icon = getFileIcon(fileExtension);

  return <Icon className={className} height={16} width={16} />;
};
